const skillData = [
   
    { name: "React", icon: "https://cdn-icons-png.flaticon.com/512/1126/1126012.png" },
    { name: "Node.js", icon: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png" },
    { name: "MongoDB", icon: "https://cdn-icons-png.flaticon.com/512/919/919836.png" },
   
    { name: "Ethereum", icon: "https://cdn.jsdelivr.net/npm/simple-icons@v8/icons/ethereum.svg"},
    { name: "Solidity", icon: "https://cdn.jsdelivr.net/npm/simple-icons@v8/icons/solidity.svg"},
    
  ];

  export default skillData;